var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEndorsementStatusReceived18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F7931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zM9 1.38A7.62 7.62 0 1 0 16.62 9 7.63 7.63 0 0 0 9 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08 13.38a.69.69 0 0 1-.46-.17L3.46 9.52a.69.69 0 0 1 0-1 .68.68 0 0 1 1-.06L8 11.7l5.37-6.57a.69.69 0 0 1 1-.1.7.7 0 0 1 .1 1l-5.86 7.1a.65.65 0 0 1-.48.25h-.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndorsementStatusReceived18);
export default __webpack_public_path__ + "static/media/icon-endorsement-status-received-18.9bd6672906f2cf4278158c939208b924.svg";
export { ForwardRef as ReactComponent };